import { Row } from "@omni/components/components/General/Grid/row.component";
import { Price } from "@omni/components/components/Price/price";
import { Cashback as CashbackBase } from "@omni/components/components/Product/ECommerce/components/pricing/components/cashback/cashback";
import { Discount as DiscountBase } from "@omni/components/components/Product/ECommerce/components/pricing/components/discount/discount";
import { EveryDayLowPrice as EveryDayLowPriceBase } from "@omni/components/components/Product/ECommerce/components/pricing/components/everyDayLowPrice/everyDayLowPrice";
import { Pricing } from "@omni/components/components/Product/ECommerce/components/pricing/pricing";
import { useECommerceProduct } from "@omni/components/components/Product/ECommerce/hooks/useECommerceProduct.hook";
import { cn } from "@omni/utils/styles";

export const PricingComponent = () => {
    const {
        currentPrice,
        strikethroughPrice,
        currentConversionPrice,
        conversionUnit
    } = useECommerceProduct();

    return (
        <>
            <div>
                <Row className={cn("tw:mb-2")}>
                    <Pricing.WebOnly />
                </Row>
                <Pricing.Discount>
                    <Row className={cn("tw:mb-2")}>
                        <DiscountBase.ProductLabel />
                    </Row>
                    <DiscountBase.PromotionPeriode />
                </Pricing.Discount>
                <Pricing.Cashback>
                    <Row className={cn("tw:mb-2")}>
                        <CashbackBase.ProductLabel />
                    </Row>
                    <Row className={cn("tw:text-sm tw:font-normal")}>
                        <CashbackBase.PriceAfterCashbackIsApplied />
                    </Row>
                    <Row className={cn("tw:text-sm tw:font-normal")}>
                        <CashbackBase.Information />
                    </Row>
                </Pricing.Cashback>

                <Pricing.EveryDayLowPrice>
                    <Row className={cn("tw:mb-2")}>
                        <EveryDayLowPriceBase.Image />
                    </Row>
                </Pricing.EveryDayLowPrice>
            </div>
            <Price
                className={cn("tw:w-full tw:flex tw:justify-end")}
                price={currentPrice ?? 0}
                strikeThroughPrice={strikethroughPrice}
                conversionPrice={currentConversionPrice}
                conversionUnit={conversionUnit}
                size={"xl"}
            >
                {strikethroughPrice && <Price.StrikeThrough />}
                <Price.Main />
                {currentConversionPrice && conversionUnit && (
                    <Price.Conversion />
                )}
            </Price>
            <Pricing.Recupel
                className={cn("tw:w-full tw:flex tw:justify-end")}
            />
        </>
    );
};
